import { SearchOutlined  } from "@ant-design/icons";
import {
    DeleteButton,
    EditButton,
    List,
    TextField,
    useTable,
} from "@refinedev/antd";
import { debounce } from "lodash"; 
import { useUpdate, useDelete } from "@refinedev/core";
import { Space, Table, Button, Form, Input, Select, notification, Spin, Popover } from "antd";
import { useState } from "react";
import { format, formatDistanceToNow } from "date-fns";
import Title from "antd/es/typography/Title";

export const AdminList = () => {
    const [hoveredRow, setHoveredRow] = useState<string>(""); // Track hovered row

    const handleMouseEnter = (id: string) => {
        setHoveredRow(id); // Set the row id when mouse enters
    };

    const handleMouseLeave = () => {
        setHoveredRow(""); // Reset the hover state when mouse leaves
    };

    const { mutate: updateStaus, variables, isLoading: statusLoading } = useUpdate({
        resource: "admin",
        mutationMode: "optimistic",
        mutationOptions: {
            retry: 3,
            onSuccess: (data) => {
                notification.success({
                    message: "Success",
                    description: data?.data?.message,
                })
            },
            onError: (error) => {
                console.error("Error updating user status:", error);
            },
        }
    });

    const handleToggleStatus = (id: string, currentStatus: boolean) => {
        // console.log('Current status:', currentStatus);
        updateStaus({
            id, 
            values: { isActive: !currentStatus },
        });
    }

    const { tableProps, searchFormProps, } = useTable({
        syncWithLocation: true,
        queryOptions: {
            keepPreviousData: false,
            cacheTime: 20,
        },
        onSearch: (values: any) => {
            // console.log("Search being triggered with values:", values);
            return [
                {
                    field: "q",
                    operator: "contains",
                    value: values.q,
                },
                {
                    field: "status",
                    operator: "eq",
                    value: values.status ? values.status.join(',') : undefined,
                },
            ]
        }
    });

    const handleSearchChange = debounce(() => {
        // console.log("Form change being triggered");
        searchFormProps.form?.submit();
    }, 500);

    // console.log("ADMINS:", tableProps.dataSource)

    return (
        <div style={{ padding: "4px", position: "relative", }}>
            <div style={{
                display: "flex",
                flexWrap: "wrap",
                gap: 10,
                width: "100%",
                justifyContent: "flex-end",
                alignItems:"flex-start",
            }}>
                <Form {...searchFormProps} onValuesChange={handleSearchChange}>
                    <Title level={4}>Filter and Search</Title>
                    <div style={{ display: "flex", gap: 10}}>
                        <Form.Item name="status" >
                            <Select
                                placeholder="Select status"
                                allowClear
                                style={{ width: 150 }}
                                mode="multiple"
                            >
                                <Select.Option value="active">Active</Select.Option>
                                <Select.Option value="inactive">Inactive</Select.Option>
                            </Select>
                        </Form.Item>
                        <Form.Item name="q">
                            <Input  placeholder="Search by name, username, email, phone number" />
                        </Form.Item>
                    </div>
                </Form>
            </div>
            <List>
                <Table {...tableProps} rowKey="id">
                    {/* <Table.Column dataIndex="id" title={"ID"} /> */}
                    <Table.Column dataIndex="fullName" title={"Full name"} />
                    <Table.Column dataIndex="email" title={"Email"} />
                    <Table.Column dataIndex="role" title={"Role"} />
                    <Table.Column
                        dataIndex="lastActiveOn"
                        title={"Last active on"}
                        render={(value, record) => (
                            <div
                                onMouseEnter={() => handleMouseEnter(record.id)}
                                onMouseLeave={handleMouseLeave}
                            >
                                <Popover content={format(value, "MM/dd/yy hh:mm a")}>
                                    <span>
                                        {formatDistanceToNow(value)} ago
                                    </span>
                                </Popover>
                            </div>
                        )}
                    />
                    <Table.Column
                        dataIndex="status"
                        title={"Status"} 
                        render={(_, record: any) => {
                            return (
                                <Space style={{
                                    color: record?.isActive ? "green" : "red"
                                }}>
                                    {record.isActive ? ("Active") : ("Inactive")}
                                </Space>
                            )
                        }}
                    /> 
                    <Table.Column 
                        title={"Actions"}
                        dataIndex="actions"
                        render={(_, record: any) => (
                            <Space>
                                <EditButton hideText size="small" recordItemId={record.id} />
                                <DeleteButton hideText size='small' recordItemId={record.id} />
                                <Button
                                        style={{
                                            width: 100,
                                            color: record.isActive ? "red" : "green",
                                        }}
                                        onClick={() => handleToggleStatus(record.id, record.isActive)}
                                    >
                                    {record.isActive
                                      ? statusLoading && (variables && variables.id === record.id) ? <Spin /> : "Deactivate"
                                      : statusLoading && (variables && variables.id === record.id) ? <Spin /> : "Activate"
                                    }
                                </Button>
                            </Space>
                        )}
                    />
                </Table>
            </List>
        </div>
    )
}